<app-multiselect-tags #funcExp class="w-100" [showTagClose]="true"
    [filedName]="'Common.Users'" [autoCompleteList]="dataSource"
    [selectedItems]="selectedValues" (onSelect)="selectItem($event)" (onType)="onType($event)"></app-multiselect-tags>
